import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { colors, Icon } from '@cimpress/react-components';
import Button from '../../common/Button';
import { css } from 'emotion';
import EditNameModal from './EditNameModal';
import { withTranslation } from 'react-i18next';

const linkTextStyle = css`
  margin-left: 10px;
  margin-right: 5px;
`;

class EditNameButton extends Component {
  static defaultProps = {};

  static propTypes = {
    termRevision: PropTypes.object.isRequired,
    setLatestRevision: PropTypes.func
  };

  state = {
    modalOpened: false
  };

  onOpenModal = () => {
    this.setState({ modalOpened: true });
  };

  onCloseModal = () => {
    this.setState({ modalOpened: false });
  };

  render() {
    const { modalOpened } = this.state;
    const { termRevision, setLatestRevision, t } = this.props;
    return (
      <>
        <Button bsStyle="link" onClick={this.onOpenModal}>
          <small className={linkTextStyle}>{t('common:commonWords.edit')}</small>
          <Icon name="pencil-2-l" color={colors.ocean.base} />
        </Button>
        {modalOpened && (
          <EditNameModal
            modalOpened={modalOpened}
            onCloseModal={this.onCloseModal}
            termRevision={termRevision}
            setLatestRevision={setLatestRevision}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(EditNameButton);
